// Bucket color mapping for proof visualizations
const BUCKET_COLORS: Record<string, string> = {
  "<30min": "bg-green-500",
  "30min-1hr": "bg-yellow-500",
  "1-2hr": "bg-orange-500",
  "2hr+": "bg-red-500",
  ignored: "bg-red-800",
  "<5min": "bg-green-500",
  "5-15min": "bg-yellow-500",
  "15min+": "bg-red-500",
  "5-30min": "bg-yellow-500",
  "30min-2hr": "bg-orange-500",
  manychat: "bg-purple-400",
  outbound_no_reply: "bg-amber-400",
  ghost: "bg-red-400",
  light: "bg-yellow-400",
  engaged: "bg-green-500",
  deep: "bg-blue-500",
  // Reply turn depth tiers — red (0) → green (19+)
  "0": "bg-red-500",
  "1": "bg-red-400",
  "2": "bg-orange-500",
  "3": "bg-orange-400",
  "4": "bg-amber-400",
  "5": "bg-yellow-400",
  "6": "bg-yellow-500",
  "7": "bg-lime-400",
  "8": "bg-lime-500",
  "9": "bg-green-400",
  "10": "bg-green-500",
  "11_12": "bg-emerald-500",
  "13_18": "bg-teal-500",
  "19plus": "bg-cyan-500",
  replied: "bg-green-500",
  no_reply: "bg-red-400",
  // Follow-up persistence: forgiving gradient (even 1d follow-up is decent)
  "1d": "bg-yellow-400",
  "2d": "bg-lime-400",
  "3d": "bg-green-500",
  "4d": "bg-green-500",
  "5d": "bg-green-500",
  "6d": "bg-green-500",
  "7d": "bg-green-500",
  "7+d": "bg-green-500",
  // Speed to Lead: pending = lead's first DM < 4h old, no verdict yet (censored, not a failure)
  pending: "bg-gray-400",
  // Conversation span
  same_day: "bg-gray-400",
  "1-2d": "bg-blue-400",
  "3-6d": "bg-green-500",
  "1-2w": "bg-yellow-400",
  "2w+": "bg-orange-500",
  // Unreplied — severity climbs with hours since the lead's last message
  "0_4h": "bg-yellow-400",
  "4_24h": "bg-orange-400",
  "24_48h": "bg-orange-500",
  "48h_plus": "bg-red-500",
};

export function getBucketColor(bucket: string): string {
  return BUCKET_COLORS[bucket] || "bg-gray-400";
}

// Human-readable labels for bucket names
const BUCKET_LABELS: Record<string, string> = {
  ghost: "No Reply",
  outbound_no_reply: "Outbound",
  manychat: "ManyChat",
  no_reply: "No Reply",
  pending: "Pending (<4h)",
  "0": "0 replies",
  "1": "1 reply",
  "2": "2 replies",
  "3": "3 replies",
  "4": "4 replies",
  "5": "5 replies",
  "6": "6 replies",
  "7": "7 replies",
  "8": "8 replies",
  "9": "9 replies",
  "10": "10 replies",
  "11_12": "11-12 replies",
  "13_18": "13-18 replies",
  "19plus": "19+ replies",
  // Unreplied — hours since the lead's last message, no setter reply yet
  "0_4h": "0-4h",
  "4_24h": "4-24h",
  "24_48h": "24-48h",
  "48h_plus": "48h+",
};

export function getBucketLabel(bucket: string): string {
  return BUCKET_LABELS[bucket] || bucket;
}
